import { Theme } from '@mui/material';
import React from 'react';
import { TECEO_LOGIN_BACKGROUND_PATH } from '../utils/images.constants';

export const authBackgroundStyle = (theme: Theme, backgroundUrl?: string): React.CSSProperties => ({
  display: 'flex' as const,
  flexDirection: 'column' as const,
  justifyContent: 'center' as const,
  alignItems: 'center' as const,
  height: '100vh',
  backgroundColor: theme.palette.accent.dark,
  backgroundImage: `url('${backgroundUrl || TECEO_LOGIN_BACKGROUND_PATH}')`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  [theme.breakpoints.only('xs')]: {
    minHeight: '100vh',
    height: 'auto',
  },
});
